import { Box, Typography } from "@mui/material";
import { aggregateBasketLayersByMaterial } from "components/common/plan/utils";
import { useMaterials } from "hooks/useMaterials";
import { useMemo } from "react";
import { type MixRead } from "src/store/api/generatedApi";

export const CompactMixDisplay = ({ mix }: { mix: MixRead }) => {
  const { materials } = useMaterials();
  const orderingByName = useMemo(() => {
    const lookup: Record<string, number> = {};
    (materials ?? []).forEach((material) => {
      lookup[material.name] = material.ordering;
    });
    return lookup;
  }, [materials]);

  const aggregated = useMemo(() => {
    const basketOne = mix.baskets.find((basket) => basket.basket_number === 1);
    return aggregateBasketLayersByMaterial(
      basketOne?.layers ?? [],
      orderingByName
    );
  }, [mix.baskets, orderingByName]);

  const ratioMaterials = aggregated.filter(
    (material) => material.unit === "ratio"
  );
  const grabMaterials = aggregated.filter(
    (material) => material.unit === "grab"
  );

  return (
    <Box>
      {ratioMaterials.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 0.5,
            borderBottom: 1,
            borderColor: "grey.100",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: "fontWeightMedium", fontSize: 14 }}
          >
            {ratioMaterials.map((material) => material.materialName).join(":")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "fontWeightBold",
              color: "primary.main",
              fontSize: 14,
            }}
          >
            {ratioMaterials.map((material) => material.totalMass).join(":")}
          </Typography>
        </Box>
      )}

      {grabMaterials.map((material) => (
        <Box
          key={material.materialName}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 0.5,
            borderBottom: 1,
            borderColor: "grey.100",
            opacity: material.totalMass === 0 ? 0.5 : 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: "fontWeightMedium", fontSize: 14 }}
          >
            {material.materialName}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "fontWeightBold",
              color: "primary.main",
              fontSize: 14,
            }}
          >
            +{material.totalMass}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
